namespace app.support {
    export class PollerService {
        
        public constructor(private $interval: ng.IIntervalService) {
            
        }
        
        public poll(actionFn: () => ng.IPromise<{}>, dataFn: Function, duration: number = 5000): Function {
            let pollingTimer;
            let stopPolling = false;
            let tick = () => {
                actionFn().then((data) => {
                    dataFn(data);
                }).finally(() => {
                    if (!stopPolling) {
                        pollingTimer = this.$interval(tick, duration, 1);
                    }
                });
            };
            tick();
            return () => {
                stopPolling = true;
            };
        }
        
    }
    
    angular.module("app.support").service("pollerService", PollerService);
}